import { Row as AntRow, Col } from 'antd';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Project } from 'api/project';
import { Avatar } from 'components/atoms/avatar';
import { Breadcrumb } from 'components/atoms/breadcrumb';
import { ProjectDuration } from 'components/molecules/project-duration';
import { ClassNameProps } from 'components/ozone-component';
import { Text02, Caption01 } from 'components/styles';

const Row = styled(AntRow)`
  align-items: center;
  margin-bottom: var(--spacing-03);
  padding: 0 var(--layout-01);

  h6 {
    margin-bottom: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const DateCaption = styled.small`
  ${Caption01};
  ${Text02};
  align-items: center;
  display: flex;
`;

export const ProjectName = styled.h6`
  margin-bottom: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const BreadcrumbRow = styled(Row)`
  margin-bottom: var(--layout-01);
`;

export const ProjectMiniDetail: FC<{ project: Project } & ClassNameProps> = ({
  project,
  className,
}) => {
  const { startDate, dueDate, projectName } = project;

  return (
    <div className={className}>
      <ProjectName>{projectName}</ProjectName>
      {startDate || dueDate ? (
        <ProjectDuration
          startDate={startDate ? moment(startDate) : null}
          dueDate={dueDate ? moment(dueDate) : null}
        />
      ) : null}

      {dueDate ? (
        <DateCaption>
          <FormattedMessage
            id="days_in_difference"
            values={{
              count: moment(dueDate || +new Date()).diff(startDate, 'day'),
            }}
          />
        </DateCaption>
      ) : null}
    </div>
  );
};

export const ProjectSidebarDetail: FC<{ project: Project }> = ({ project }) => {
  return (
    <>
      <BreadcrumbRow>
        <Col span={24}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/projects">
                <FormattedMessage id="breadcrumbs.projects" />
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </BreadcrumbRow>
      <Row gutter={16}>
        <Col>
          <Avatar
            shape="square"
            src={project.customer?.companyLogoUrl}
            name={project.customer?.companyName || project.projectName}
            size="large"
          />
        </Col>
        <Col span={18}>
          <ProjectMiniDetail project={project} />
        </Col>
      </Row>
    </>
  );
};
